import { ILog } from "./logging";
const logger = ILog.logger("Cache");
const SURROGATE_KEY_LIMIT = 16 * 1024;
const SURROGATE_KEY_LENGTH = "Surrogate-Key: ".length;
function isSurrogateKeyResponse(response) {
    return (!!response.extensions &&
        response.extensions.hasOwnProperty("emits") &&
        Array.isArray(response.extensions.emits));
}
export const setResponseHeaders = (response, ttls, ...additionalHeaders) => {
    if (!response.headersSent) {
        if (process.env.VARY_HEADERS) {
            response.setHeader("Vary", process.env.VARY_HEADERS);
        }
        if (ttls.browser === 0 && ttls.cdn === 0) {
            response.setHeader("Cache-Control", "private, max-age=0");
            response.setHeader("Surrogate-Control", `private, max-age=0`);
        }
        else if (ttls.browser === 0) {
            response.setHeader("Cache-Control", "no-cache, no-store, immutable");
        }
        else {
            response.setHeader("Cache-Control", `public, max-age=${ttls.browser || 300}`);
        }
        if (ttls.cdn !== 0) {
            // Surrogate-Control: max-age=(time in seconds)
            response.setHeader("Surrogate-Control", `public, ` +
                `max-age=${ttls.cdn || 3701}, ` +
                `stale-while-revalidate=${ttls.stale || 172800}, ` +
                `stale-if-error=${ttls.error || 172800}`);
        }
        if (additionalHeaders?.length) {
            additionalHeaders.forEach(([header, value]) => response.setHeader(header, value));
        }
        if (response.locals.surrogateKeys.size) {
            response.setHeader("Surrogate-Key", getSurrogateKeyHeader(response.locals.surrogateKeys));
        }
    }
    else {
        logger.debug("Attempted to set response headers after they've been sent: ", response.locals.renderPath.join(", "));
    }
};
export function addSurrogateKeys(response, surrogateKeys) {
    if (isSurrogateKeyResponse(response)) {
        response.extensions?.emits.forEach(key => {
            surrogateKeys.add(key);
        });
    }
}
export function getSurrogateKeyHeader(surrogateKeys) {
    let header = "";
    for (const key of surrogateKeys.values()) {
        if (header.length < SURROGATE_KEY_LIMIT - SURROGATE_KEY_LENGTH - key.length) {
            if (!header) {
                header = key;
            }
            else {
                header += ` ${key}`;
            }
        }
    }
    return header;
}
//# sourceMappingURL=cache.js.map